import { ExportsGroupingFilter } from '@aibees/elephant/components/export-grouping-filter';
import { ExportTableName } from '@aibees/elephant/components/export-table-name';
import { SearchBarFilter } from '@aibees/elephant/components/search-bar-filter';
import { TableLabelType } from '@aibees/elephant/components/table-label-type';
import { ExportFileStatusCell } from '@aibees/elephant/feature/exports-management-table/components/export-file-status-cell';
import {
  BrowseSearchExportsRequest,
  ExportItem,
  ExportSearchGrouping,
} from '@aibees/elephant/hooks';
import { useBrowseSearchExports } from '@aibees/elephant/hooks/use-browse-search-exports';
import {
  DateTime,
  TableCellTypography,
  TextEllipsis,
  UserShortName,
} from '@aibees/shared/components';
import { AdvanceTableConfig } from '@aibees/shared/features';
import {
  DATE_FORMAT_YYYY_MM_DD_hh_mm_a,
  fHumanReadableNumber,
} from '@aibees/shared/utils';
import { CardBodyTotalRecords } from '../../styles';
import { ExportTableAction } from './actions/export-table-action';
import { ExportTableViewRecordsAction } from './actions/export-table-action/export-table-view-records-action';
import * as SX from './sx';

export const config: AdvanceTableConfig<
  ExportItem,
  BrowseSearchExportsRequest
> = {
  columns: [
    {
      id: 'name',
      label: 'Name',
      sortable: 'name.keyword',
      width: 120,
      render: (_, v) => <ExportTableName item={v} />,
    },
    {
      id: 'grouping',
      label: 'Type',
      sortable: 'grouping',
      width: 96,
      render: (_, v) => (
        <TableLabelType
          isCompany={v.grouping === ExportSearchGrouping.COMPANY}
        />
      ),
    },
    {
      id: 'records',
      label: 'Total',
      sortable: 'records',
      width: 70,
      render: (v) => (
        <CardBodyTotalRecords>{fHumanReadableNumber(v)}</CardBodyTotalRecords>
      ),
    },
    {
      id: 'workspace',
      label: 'Team',
      sortable: 'workspace.user.id',
      width: 80,
      render: (_, v) => (
        <TextEllipsis>
          <TableCellTypography
            item={<UserShortName user={v.workspace.user} />}
          />
        </TextEllipsis>
      ),
    },
    {
      id: 'created',
      label: 'Last Modified',
      sortable: 'created',
      width: 114,
      render: (v, d) => (
        <DateTime
          value={v ?? d.created}
          format={DATE_FORMAT_YYYY_MM_DD_hh_mm_a}
        />
      ),
    },
    {
      id: 'status',
      label: 'Status',
      sortable: 'status',
      width: 96,
      render: (_, v, i) => <ExportFileStatusCell item={v} rowNumber={i} />,
      align: 'center',
    },
  ],
  actions: [ExportTableViewRecordsAction, ExportTableAction],
  browseApi: useBrowseSearchExports,
  initialFilters: { grouping: ExportSearchGrouping.ALL },
  filters: [SearchBarFilter, ExportsGroupingFilter],
  actionsConfig: {
    label: 'Action',
    minWidth: '10%',
    align: 'center',
    sx: { display: 'flex', justifyContent: 'center', alignItems: 'center' },
  },
  stickyHeader: true,
  defaultOrderBy: 'created',
  hideColumnsOnNoData: true,
  showTablePrependOnNotFound: true,
  emptyProps: {
    emptyIcon: 'export',
    emptyIconWrapperSX: SX.emptyIconWrapper,
    titleSx: { fontSize: 14 },
    iconSize: 28,
  },
  hideResetFilters: true,
  cellSx: { px: 0.5, py: 1 },
  bordered: 'solid',
  rowsPerPageOptions: [5],
  showJumpToPage: false,
  showPageSelector: false,
  filtersSx: { flexDirection: 'row !important' },
};
